import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Icon, Dropdown, Menu, Modal } from "antd";
import moment from "moment";

import DrawerDetalheFaltaJustificada from "./DetalheFaltaJustificadaDrawer";

import { useAxios } from "../../../../shared/hooks/useAxios";
import { useNotification } from "../../../../shared/hooks/useNotification";

const confirm = Modal.confirm;

const FaltasJustificadasDrawer = ({ inscricao, visible, onClose }) => {
    const [faltaJustificadaId, setFaltaJustificadaId] = useState(0);
    const [faltasJustificadas, setFaltasJustificadas] = useState([]);
    const [visibleAdicionarFalta, setVisibleAdicionarFalta] = useState(false);

    const { loading, notAuthorized, fetchData } = useAxios();
    const notify = useNotification();

    const carregarFaltasJustificadas = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/faltas-justificadas",
            params: {
                inscricaoId: inscricao.id
            }
        });

        if (!error) {
            setFaltasJustificadas(data);
        } else {
            notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
        }
    };

    const excluirFaltaJustificada = async faltaJustificadaId => {
        confirm({
            title: "Pretende excluir esta falta justificada?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: async () => {
                const { error } = await fetchData({
                    method: "delete",
                    url: `/api/faltas-justificadas/${faltaJustificadaId}`
                });

                if (!error) {
                    notify.success("Sucesso", "Falta justificada excluída!");
                    carregarFaltasJustificadas();
                } else {
                    notify.error("Erro", error || "Ocorreu um erro inesperado. Por favor, tente novamente.");
                }
            }
        });
    };

    const calcularDias = falta => {
        if (falta.dataTermino == null) {
            return 1;
        }

        const dataInicio = moment(falta.dataInicio);
        const dataTermino = moment(falta.dataTermino);
        return dataTermino.diff(dataInicio, "days") + 1;
    };

    const calcularTotalDias = () => {
        let totalDias = 0;

        faltasJustificadas.forEach(falta => {
            totalDias += calcularDias(falta);
        });

        return totalDias;
    };

    const calcularTotalAulasAfetadas = () => {
        let totalAulas = 0;

        faltasJustificadas.forEach(falta => {
            totalAulas += falta.totalAulasAfetadas;
        });

        return totalAulas;
    };

    const montarMenu = faltaId => {
        return (
            <Menu>
                <Menu.Item
                    key="1"
                    onClick={() => {
                        setFaltaJustificadaId(faltaId);
                        setVisibleAdicionarFalta(true);
                    }}
                >
                    Editar
                </Menu.Item>
                <Menu.Item key="2" onClick={() => excluirFaltaJustificada(faltaId)}>
                    Excluir
                </Menu.Item>
            </Menu>
        );
    };

    const montarDatas = falta => {
        const dataInicio = moment(falta.dataInicio).format("DD/MM/YYYY");

        if (falta.dataTermino == null) {
            return dataInicio;
        } else {
            const dataTermino = moment(falta.dataTermino).format("DD/MM/YYYY");

            return (
                <>
                    {dataInicio} <Icon type="arrow-right" /> {dataTermino}
                </>
            );
        }
    };

    const afterVisibleChange = visible => {
        if (visible) {
            carregarFaltasJustificadas();
        }
    };

    return (
        <>
            <Drawer
                className="drawer-add-cursos drawer-faltas-justificadas"
                width={720}
                onClose={onClose}
                closable={false}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <header className="drawer-header">
                    <div>
                        <h3>Faltas justificadas</h3>
                        <p className="student-info">
                            <strong>{inscricao?.nome}</strong> <span>· {inscricao?.codigo}</span>
                        </p>
                    </div>
                    <div>
                        <button
                            className="btn-adiconar"
                            onClick={() => {
                                setFaltaJustificadaId(0);
                                setVisibleAdicionarFalta(true);
                            }}
                        >
                            <i className="fas fa-plus" /> Adicionar
                        </button>
                        <button className="btn-fechar" onClick={onClose}>
                            <i className="fas fa-times" />
                        </button>
                    </div>
                </header>

                <main className="drawer-content">
                    <section className="stats-container">
                        <div className="stat-box">
                            <small>Dias</small>
                            <output>{calcularTotalDias()}</output>
                        </div>
                        <div className="stat-box">
                            <small>Aulas afetadas</small>
                            <output>{calcularTotalAulasAfetadas()}</output>
                        </div>
                    </section>

                    <section className="log-list">
                        {loading && (
                            <div className="loading">
                                <Icon type="loading" />
                                <p>Carregando faltas justificadas...</p>
                            </div>
                        )}
                        {!loading && faltasJustificadas.length === 0 && (
                            <div className="no-results">
                                <p>Não há faltas justificadas para exibir.</p>
                            </div>
                        )}
                        {!loading &&
                            faltasJustificadas.map(falta => (
                                <article key={falta.id} className="log-card">
                                    <header className="log-card-header">
                                        <strong className="category-label">{falta.motivo}</strong>
                                        <span>{montarDatas(falta)}</span>
                                    </header>

                                    <footer className="log-card-footer">
                                        <div className="status-badge">
                                            {falta.existeAnexo ? (
                                                <span className="with-document">Com documento</span>
                                            ) : (
                                                <span className="no-document">Sem documento</span>
                                            )}
                                            <mark>{falta.totalDias} dias</mark>
                                            <Dropdown
                                                overlay={montarMenu(falta.id)}
                                                placement="bottomLeft"
                                                overlayStyle={{
                                                    zIndex: 1050
                                                }}
                                            >
                                                <Link to="#">
                                                    <i className="fas fa-cog actions" />
                                                </Link>
                                            </Dropdown>
                                        </div>
                                    </footer>
                                </article>
                            ))}
                    </section>
                </main>
            </Drawer>
            <DrawerDetalheFaltaJustificada
                inscricaoId={inscricao?.id}
                faltaJustificadaId={faltaJustificadaId}
                visible={visibleAdicionarFalta}
                onClose={() => setVisibleAdicionarFalta(false)}
                atualizarFaltasJustificadas={carregarFaltasJustificadas}
            />
        </>
    );
};

export default FaltasJustificadasDrawer;
